/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_No_Templates_KindInputs */

const cs_templates_no_templates_kind = /** @type {(inputs: Templates_No_Templates_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív vytvořte šablonu pro tuto kategorii a nastavte ji jako výchozí.`)
};

const en_templates_no_templates_kind = /** @type {(inputs: Templates_No_Templates_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a template for this kind first, then set one as default.`)
};

/**
* | output |
* | --- |
* | "Create a template for this kind first, then set one as default." |
*
* @param {Templates_No_Templates_KindInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_no_templates_kind = /** @type {((inputs?: Templates_No_Templates_KindInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_No_Templates_KindInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_no_templates_kind(inputs)
	return cs_templates_no_templates_kind(inputs)
});